import React                from "react";
import Store                from "Dashboard/Core/Store";
import Action               from "Dashboard/Core/Action";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import ProvinceEdit         from "./ProvinceEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The Province List
 * @returns {React.ReactElement}
 */
function ProvinceList() {
    const { fetch, load } = useList("province");

    const data = Store.useState("province");
    const { loading, canEdit, list, total, sort } = data;

    const { deleteElem } = Store.useAction("province");


    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "provinceID", elemID, "name");

    return <Main>
        <Header message="PROVINCES_NAME" icon="province">
            <ActionList data={data} onAction={startAction} />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="PROVINCES_NONE_AVAILABLE"
                isLoading={loading}
            >
                <TableHead>
                    <TableHeader field="provinceCode" message="GENERAL_CODE" maxWidth="100" />
                    <TableHeader field="name"         message="GENERAL_NAME" isTitle />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.provinceID} elemID={elem.provinceID}>
                        <TableCell message={elem.provinceCode} />
                        <TableCell message={elem.name}         />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="EDIT"   message="PROVINCES_EDIT_TITLE"   />
                    <TableAction action="DELETE" message="PROVINCES_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <ProvinceEdit
            open={action.isVCE}
            elemID={elemID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="PROVINCES_DELETE_TITLE"
            message="PROVINCES_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

export default ProvinceList;
